<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :toPdf="toPdf"></MulReportHeader>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" ref="tableRef" :max-height="maxHeight"></Table>
        <Modal v-model="activeModel.show" width="800">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>线上活动</span>
            </p>
            <Table border :columns="activeModel.columns" :data="activeModel.data" style="margin-top: 12px" :max-height="500"></Table>
        </Modal>
        <Modal v-model="taskModel.show" width="700">
            <p slot="header" style="color: #1c2438; text-align: center">
                <span>任务统计</span>
            </p>
            <Table border :columns="taskModel.columns" :data="taskModel.data" style="margin-top: 12px" :max-height="500"></Table>
        </Modal>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'SummaryOfWinnings',
    components: { MulReportHeader },
    data() {
        return {
            maxHeight: 800,
            loading: false,
            TransTopReqTimer: null,
            otherName: 'VIP系统数据',
            backName: '限时首充返利',
            //活动数据
            // GetZhuanPanActiveData
            activeModel: {
                show: false,
                data: [],
                app_id: -1,
                list: [
                    { name: '转入返利', _func: 'GetRebateActiveData', params: { act_type: null } },
                    { name: '转盘活动', _func: 'GetZhuanPanActiveData', params: { act_type: 5 } },
                    { name: '分享彩金', _func: 'GetZhuanPanActiveData', params: { act_type: 6 } },
                    { name: '每日返利', _func: 'GetZhuanPanActiveData', params: { act_type: 7 } },
                    { name: '首充返利', _func: 'GetZhuanPanActiveData', params: { act_type: 8 } },
                    { name: '转运金活动', _func: 'GetSubsidyData' },
                    { name: '每日转入红包', _func: 'GetDayPayRedData' },
                    { name: '签到彩金', _func: 'GetUserThreeSginRecord' },
                    { name: '推广彩金', _func: 'GetUserShareGiveRecord' },
                    { name: '保险金', _func: 'GetInsuranceRecord' },
                    { name: '每日礼金', _func: 'GetDailyGiftMoney', params: { gift_money_type: 1 } },
                    { name: '每周礼金', _func: 'GetDailyGiftMoney', params: { gift_money_type: 2 } },
                    { name: '每月礼金', _func: 'GetDailyGiftMoney', params: { gift_money_type: 3 } },
                    { name: '限时首充返利', _func: 'GetLimitFirstPayBackData' },
                    { name: 'VIP系统数据', _func: 'GetVipRecordPointLogData' },
                    { name: '连续转入红包', _func: 'GetDailyRedpackData' }
                ],
                columns: [
                    { key: 'activeName', align: 'center', title: '活动名称' },
                    {
                        key: 'user_num',
                        align: 'center',
                        title: '参与人数',
                        render: (h, params) => {
                            if (params.row.activeName == this.otherName) {
                                return h('div', [h('div', '领取晋级彩金人数：' + params.row.vip_reward_num), h('div', '领取VIP周礼金人数：' + params.row.week_num), h('div', '领取VIP月礼金人数：' + params.row.month_num)])
                            } else {
                                return h('span', params.row.user_num)
                            }
                        }
                    },
                    {
                        key: 'complete_num',
                        align: 'center',
                        title: '完成次数',
                        render: (h, params) => {
                            if (params.row.activeName == this.backName) {
                                return h('div', params.row.receive_u_num + '人，' + params.row.complete_num + ' 次')
                            } else {
                                return h('span', params.row.complete_num)
                            }
                        }
                    },
                    {
                        key: 'money_ok',
                        align: 'center',
                        title: '活动支出',
                        render: (h, params) => {
                            if (params.row.activeName == this.otherName) {
                                return h('div', [h('div', '领取晋级彩金金额：' + this.getCustomFixed(params.row.vip_reward_sum / 10000)), h('div', '领取VIP周礼金金额：' + this.getCustomFixed(params.row.week_sum / 10000)), h('div', '领取VIP月礼金金额：' + this.getCustomFixed(params.row.month_sum / 10000))])
                            } else {
                                return h('span', this.getCustomFixed(params.row.money_ok / 10000))
                            }
                        }
                    }
                ]
            },
            //任务数据
            taskModel: {
                show: false,
                app_id: -1,
                data: [],
                list: [
                    { global_task_type: 1, name: '单笔转入' },
                    { global_task_type: 2, name: '累计转入' },
                    { global_task_type: 3, name: '流水任务' },
                    { global_task_type: 4, name: '赢钱任务' },
                    { global_task_type: 5, name: '签到任务' },
                    { global_task_type: 7, name: '游戏活跃' }
                ],
                columns: [
                    { key: 'taskName', align: 'center', title: '活动名称' },
                    { key: 'total_ok_user_num', align: 'center', title: '完成人数' },
                    { key: 'total_read_point', align: 'center', title: '被领取奖励', render: (h, params) => h('span', this.getCustomFixed(params.row.total_read_point / 10000)) },
                    { key: 'total_un_read_point', align: 'center', title: '未被领取奖励', render: (h, params) => h('span', this.getCustomFixed(params.row.total_un_read_point / 10000)) }
                ]
            },
            table: {
                params: {
                    platids: [],
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    { type: 'index', title: '序号', align: 'center', width: 60 },
                    { key: 'app_name', width: 110, align: 'center', renderHeader: (h) => this.renderHeader(h, '盘口', '显示对应的盘口名称') },
                    { key: 'give_pay_sum', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '线下彩金', '筛选时间内,盘口线下彩金'), render: (h, params) => h('span', this.getCustomFixed(params.row.give_pay_sum / 10000)) },
                    { key: 'pay_back_rate', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '线下彩金/转入比', '筛选时间内,盘口线下彩金/转入比'), render: (h, params) => h('span', (params.row.pay_back_rate * 100 || 0).toFixed(2) + '%') },
                    { key: 'online_pay_back_sum', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '线上彩金', '筛选时间内,盘口线上彩金'), render: (h, params) => h('span', this.getCustomFixed((params.row.give_sum - params.row.give_pay_sum) / 10000)) },
                    { key: 'online_pay_back_rate', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '线上彩金/转入比', '筛选时间内,盘口线上彩金/转入比'), render: (h, params) => h('span', (params.row.online_pay_back_rate * 100 || 0).toFixed(2) + '%') },
                    { key: 'give_sum', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '总彩金', '筛选时间内,盘口总彩金'), render: (h, params) => h('span', this.getCustomFixed(params.row.give_sum / 10000)) },
                    { key: 'pay_sum', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '总转入金额', '筛选时间内,盘口总转入金额'), render: (h, params) => h('span', this.getCustomFixed(params.row.pay_sum / 10000)) },
                    { key: 'all_pay_rate', minWidth: 80, align: 'center', renderHeader: (h) => this.renderHeader(h, '总彩金/转入比', '筛选时间内,盘口总彩金/转入比'), render: (h, params) => h('span', (params.row.all_pay_rate * 100 || 0).toFixed(2) + '%') },
                    {
                        key: '',
                        minWidth: 200,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', { style: { 'text-align': 'left' } }, [h('Button', { props: { type: 'info' }, style: { marginRight: '8px' }, on: { click: (e) => this.showActive(params.row) } }, '活动数据'), h('Button', { props: { type: 'info' }, on: { click: (e) => this.showTask(params.row) } }, '任务数据')])
                        },
                        renderHeader: (h) => this.renderHeader(h, '详情数据', '查看详情数据')
                    }
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            let allList = this.getAllHttpAppid(this.table.params)
            // GetRebateActiveData
            let httpList = []
            let loadingArr = [...allList]
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                let el = { platid, app_id, app_name }
                let param = this.getTransTopParams('GetNewPlatformGiveData2', { platid, app_id, app_name, stime, etime, general: -1, pack_no: -1, page: 1, limit: 10000, sort: 0 })
                httpList.push(param)
            }
            // GetRebateActiveData, GetUserActiveData, GetUserCompleteActiveData, GetZhuanPanActiveData, GetZhuanPanPutData, GetZhuanPanUserData, GetUserCoinRecord, GetUserVipCoinRecord, GetOneUserActiveData
            this.table.data = []
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, loadingArr)
            }
        },
        async toHttp(httpList, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList.shift()
                this.openTimer()
                TransTopReq(param).then((res) => {
                    let data = res._param.data[0]
                    data.app_name = param.app_name
                    data.platid = param.platid
                    data.app_id = param.app_id
                    data.stime = param.param._param.stime
                    data.etime = param.param._param.etime
                    data.online_pay_back_sum = data.give_sum - data.give_pay_sum
                    data.all_pay_sum = data.online_pay_back_sum + data.give_sum
                    let params1 = this.copyData(param)
                    params1.param._func = 'GetNewPlatfromData'
                    TransTopReq(params1).then((res1) => {
                        let data1 = res1._param.data[0]
                        data.pay_sum = data1.pay_sum
                        data.pay_back_rate = this.calcRate(data.give_pay_sum, data.pay_sum)
                        data.online_pay_back_rate = this.calcRate(data.online_pay_back_sum, data.pay_sum)
                        data.all_pay_rate = this.calcRate(data.give_sum, data.pay_sum)
                        this.table.data.push(data)
                        this.toHttp(httpList, loadingArr)
                    })
                })
            }
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        showActive(el) {
            let { platid, app_id, stime, etime } = el
            this.activeModel.show = true
            this.activeModel.data = []
            this.activeModel.app_id = app_id
            this.activeModel.list.forEach((item, index) => {
                let params = this.getTransTopParams(item._func, Object.assign({ platid, app_id, stime, etime }, item.params))
                let activeName = item.name
                TransTopReq(params).then((res) => {
                    if (app_id == this.activeModel.app_id) {
                        let list = res._param.data || res._param.list
                        if (list && list[0]) {
                            let data = this.copyData(list[0])
                            data.index = index
                            data.activeName = activeName
                            if (activeName == this.otherName) {
                                data.complete_num = '-'
                            } else {
                                data.complete_num = data.complete_num || data.read_num || data.num || data.receive_num || data.recive_user || 0
                                if (params.param._param.act_type == 8) {
                                    data.complete_num = data.add_num || 0
                                }
                                data.user_num = data.user_num || data.add_num || data.share_num || data.num || data.task_num || data.buy_num || data.receive_num || 0
                                data.money_ok = data.money_ok || data.read_point || data.point || data.receive_sum || data.real_recive_sum || 0
                                if (index > 9 && index < 13) {
                                    data.user_num = '-'
                                }
                            }
                            console.log('data====>', JSON.stringify(data))
                            let result = [...this.activeModel.data, data]
                            result.sort((a, b) => (a.index > b.index ? 1 : -1))
                            this.activeModel.data = result
                        }
                    }
                })
            })
        },
        async toPdf() {
            let item = this.table.columns.pop()
            this.maxHeight = null
            this.$nextTick(async () => {
                await this.eleToPdf()
                this.maxHeight = 800
                this.table.columns.push(item)
            })
        },
        showTask(el) {
            let { platid, app_id, stime, etime } = el
            this.taskModel.show = true
            this.taskModel.data = []
            this.taskModel.app_id = app_id
            this.taskModel.list.forEach((item) => {
                let taskName = item.name
                let params = this.getTransTopParams('GetTaskGlobalData', { platid, app_id, stime, etime, global_task_type: item.global_task_type })
                TransTopReq(params).then((res) => {
                    if (app_id == this.taskModel.app_id) {
                        res._param.taskName = taskName
                        let result = [...this.taskModel.data, res._param]
                        this.taskModel.data = result
                    }
                })
            })
        }
    }
}
</script>

<style scoped lang="less"></style>
